// Role helper utilities. `super_admin` is a strict superset of `admin`,
// so anywhere the UI checks for admin, super_admin should also pass.
export const isAdminRole = (role) => role === "admin" || role === "super_admin";
export const isAdminUser = (user) => isAdminRole(user?.role);
export const isReadOnlyGuest = (user) => user?.role === "guest";
export const canPlaceWholesaleOrder = (user) => Boolean(user && (
  isAdminUser(user) || user.role === "client" || user.role === "distributing_partner"
));
export const hasRole = (user, allowed = []) => {
  const r = user?.role;
  if (!r) return false;
  if (allowed.includes(r)) return true;
  // super_admin inherits every admin permission
  if (r === "super_admin" && allowed.includes("admin")) return true;
  // Guests see the same personnel surfaces; server-side writes remain blocked.
  if (r === "guest" && allowed.includes("personnel")) return true;
  return false;
};
